/* GIANNOPOULOS — lightweight invoice request fields (cart only). */
(function () {
  if (window.gpInvoiceReady) return;
  window.gpInvoiceReady = true;

  function init() {
    document.querySelectorAll('[data-gp-invoice]').forEach(function (section) {
      if (section.dataset.gpBound) return;
      section.dataset.gpBound = 'true';
      var invoiceChoice = section.querySelector('[data-gp-choice="yes"]');
      var fields = section.querySelector('[data-gp-invoice-fields]');
      if (!invoiceChoice || !fields) return;

      function toggle() {
        var requested = invoiceChoice.checked;
        fields.hidden = !requested;
        section.querySelectorAll('[data-gp-field]').forEach(function (input) {
          input.required = requested;
          input.setCustomValidity('');
        });
        var error = section.querySelector('[data-gp-save-error]');
        if (error) error.hidden = true;
      }

      section.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', toggle);
      });
      section.querySelectorAll('[data-gp-field]').forEach(function (input) {
        input.addEventListener('input', function () { input.setCustomValidity(''); });
      });
      toggle();
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('#CartDrawerForm, #CartPageForm')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (form.dataset.gpInvoiceState === 'resubmit') return;

    var section = form.querySelector('[data-gp-invoice]');
    if (!section) return;
    var requested = section.querySelector('[data-gp-choice="yes"]').checked;
    // Don't delay ordinary receipt checkouts unless clearing a saved invoice request.
    if (!requested && section.dataset.gpSavedChoice !== 'yes') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.gpInvoiceState === 'saving') return;

    var vat = section.querySelector('[data-gp-field="vat"]');
    var company = section.querySelector('[data-gp-field="company"]');
    if (requested) {
      var requiredMessage = section.dataset.gpRequiredMessage;
      for (var i = 0, requiredFields = [vat, company]; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        field.value = field.value.trim();
        if (!field.value) {
          field.setCustomValidity(requiredMessage);
          field.reportValidity();
          field.focus();
          return;
        }
      }
    }

    var attributes = {
      invoice_requested: requested ? 'yes' : 'no',
      invoice_vat_number: requested ? vat.value : '',
      invoice_company: requested ? company.value : ''
    };
    var body = { attributes: attributes };
    var note = form.querySelector('textarea[name="note"]');
    if (note) body.note = note.value;
    var error = section.querySelector('[data-gp-save-error]');
    if (error) error.hidden = true;
    var submitter = event.submitter || form.querySelector('button[name="checkout"]');
    form.dataset.gpInvoiceState = 'saving';
    if (submitter) submitter.disabled = true;

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }).then(function (cart) {
      var saved = cart.attributes || {};
      if (saved.invoice_requested !== attributes.invoice_requested ||
          (requested && (saved.invoice_vat_number !== attributes.invoice_vat_number ||
                         saved.invoice_company !== attributes.invoice_company))) {
        throw new Error('Cart attributes were not persisted');
      }
      form.dataset.gpInvoiceState = 'resubmit';
      if (submitter) submitter.disabled = false;
      if (form.requestSubmit && submitter) {
        form.requestSubmit(submitter);
        Promise.resolve().then(function () { form.dataset.gpInvoiceState = ''; });
      } else {
        window.location.assign((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout');
      }
    }).catch(function () {
      form.dataset.gpInvoiceState = '';
      if (submitter) submitter.disabled = false;
      if (error) { error.hidden = false; error.focus(); }
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();